import script from "./TableFull.vue?vue&type=script&setup=true&lang=js"
export * from "./TableFull.vue?vue&type=script&setup=true&lang=js"

import "./TableFull.vue?vue&type=style&index=0&id=2cc2e7f8&lang=css"

const __exports__ = script;

export default __exports__